import * as React from 'react';
import propz from 'propz';
import Moment from 'moment';
import { AppUser } from 'Src/views/App/App';
import { getEventAttendanceLog } from 'Src/helpers/service/admin/schoolEvents';
import { Loader } from 'Src/components/Loader/Loader';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';

interface Props {
  user: AppUser;
  eventId: string;
  isOpen: boolean;
  onClose: () => void;
}

interface State {
  log: any[];
  isLoading: boolean;
  errorMessage: string;
}

export class AttendanceLogModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      log: [],
      isLoading: false,
      errorMessage: ''
    };
  }

  componentDidUpdate(prevProps: Props) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.loadLog();
    }
  }

  loadLog = () => {
    const { user, eventId } = this.props;

    this.setState({ isLoading: true, errorMessage: '' });

    getEventAttendanceLog(user, eventId)
      .then(log => {
        this.setState({ log, isLoading: false });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          errorMessage: 'Failed to load attendance log'
        });
      });
  };

  renderEntry = (entry: any, index: number) => {
    const when = entry.createdAt ? Moment(entry.createdAt).format('DD MMM YYYY, HH:mm') : '—';
    const status = entry.isRemoved ? 'Removed' : entry.isAttendance ? 'Present' : 'Absent';

    const studentFirstName = propz.get(entry, ['studentData', 'firstName'], '');
    const studentLastName = propz.get(entry, ['studentData', 'lastName'], '');
    const studentName = studentFirstName || studentLastName ? `${studentLastName} ${studentFirstName}`.trim() : '—';

    const firstName = propz.get(entry, ['triggeredByUser', 'firstName'], '');
    const lastName = propz.get(entry, ['triggeredByUser', 'lastName'], '');
    const who = firstName || lastName ? `${firstName} ${lastName}`.trim() : '—';

    return (
      <tr key={index}>
        <td>{studentName}</td>
        <td>{when}</td>
        <td>
          <span className={entry.isRemoved ? 'text-muted' : entry.isAttendance ? 'text-success' : 'text-danger'}>
            {status}
          </span>
        </td>
        <td>{who}</td>
        <td>{entry.internalComment || '—'}</td>
        <td>{entry.publicComment || '—'}</td>
      </tr>
    );
  };

  render() {
    const { isOpen, onClose } = this.props;
    const { log, isLoading, errorMessage } = this.state;

    return (
      <SimpleModal
        isOpen={isOpen}
        title={'Attendance log'}
        buttonCancelText={'Close'}
        onCloseClick={onClose}
        customClass={'mAttendanceLogModal'}
      >
        {isLoading && <Loader />}

        {!isLoading && errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

        {!isLoading && !errorMessage && (
          <>
            {log.length === 0 ? (
              <div className="text-muted">No changes recorded yet.</div>
            ) : (
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Student</th>
                    <th>When</th>
                    <th>Status</th>
                    <th>Changed by</th>
                    <th>Internal note</th>
                    <th>Public comment</th>
                  </tr>
                </thead>
                <tbody>{log.map((entry, i) => this.renderEntry(entry, i))}</tbody>
              </table>
            )}
          </>
        )}
      </SimpleModal>
    );
  }
}

